import clsx from 'clsx';

type SkeletonProps = {
  isMobile?: boolean;
};

export const Skeleton: React.FC<SkeletonProps> = ({ isMobile = false }) => {
  const sizeClassName = !isMobile ? 'w-[61rem]' : 'w-full';

  return (
    <div
      className={clsx(
        'flex flex-col',
        !isMobile ? 'mx-[17.8rem]' : 'w-full mx-md'
      )}
    >
      <div
        className={clsx(
          sizeClassName,
          'mb-md h-[4rem] bg-secondary animate-pulse border-solid rounded-lg'
        )}
      ></div>
      <div
        className={clsx(
          sizeClassName,
          'mb-md h-[44rem] bg-secondary animate-pulse rounded-lg'
        )}
      ></div>
      <div className="mb-md flex items-center justify-around">
        <span className="w-[7.4rem] h-[2.4rem] bg-secondary animate-pulse rounded-lg"></span>
        <span className="w-[7.4rem] h-[2.4rem] bg-secondary animate-pulse rounded-lg"></span>
        <span className="w-[7.4rem] h-[2.4rem] bg-secondary animate-pulse rounded-lg"></span>
      </div>
      <div>
        <div className="mb-sm w-[30rem] h-[2.4rem] bg-secondary animate-pulse rounded-lg"></div>
        <div className="mb-sm w-[19rem] h-[2.4rem] bg-secondary animate-pulse rounded-lg"></div>
        <div className="mb-sm w-[10rem] h-[2.4rem] bg-secondary animate-pulse rounded-lg"></div>
      </div>
    </div>
  );
};
